/* One countdown, used by the home hero and the offer band.

   Both used to close over the timer node they found at mount. A language
   switch replaces that node while a tick is already queued, and the tick then
   writes into a node that is gone. Each tick looks the timer up again, on
   this component, and a tick that finds nothing stops. */

export function stopCountdown(vm) {
  if (vm.countdownHandle) {
    clearInterval(vm.countdownHandle);
    vm.countdownHandle = null;
  }
}

export function startCountdown(vm, date) {
  stopCountdown(vm);

  var end = date.getTime();

  var pad = function (value) {
    return String(value).padStart(2, '0');
  };

  var timer = function () {
    if (!vm.$el) {
      return null;
    }

    return vm.$el.querySelector('[data-event="timer"]');
  };

  var write = function (root, type, value) {
    var node = root.querySelector('[data-type="' + type + '"] span');

    if (node) {
      node.innerHTML = pad(value);
    }
  };

  var tick = function () {
    var root = timer();

    if (vm.stopped || !root) {
      stopCountdown(vm);
      return false;
    }

    var distance = end - Date.now();

    if (distance <= 0) {
      write(root, 'days', 0);
      write(root, 'hours', 0);
      write(root, 'minutes', 0);
      write(root, 'seconds', 0);
      stopCountdown(vm);
      return false;
    }

    write(root, 'days', Math.floor(distance / 86400000));
    write(root, 'hours', Math.floor((distance % 86400000) / 3600000));
    write(root, 'minutes', Math.floor((distance % 3600000) / 60000));
    write(root, 'seconds', Math.floor((distance % 60000) / 1000));
    return true;
  };

  if (!tick()) {
    return;
  }

  vm.countdownHandle = setInterval(tick, 1000);
}
